// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class ShowView extends JQueryView {
  constructor() {
    super('#notices-wrapper');
  }

  @on({ event: 'change', selector: '#notify_new_investee_macbee_news' })
  onClickCheckBox(event: any) {
    const notifyNewInvesteeMacbeeNews = $(event.target).is(':checked');
    const userCompanyId = $('#user_company_id').val();
    $.ajax({
      url: '/api/v1/my/vc/settings/notices',
      type: 'PATCH',
      dataType: 'json',
      data: {
        id: userCompanyId,
        notify_new_investee_macbee_news: notifyNewInvesteeMacbeeNews,
      },
    }).fail(() => {
      if (notifyNewInvesteeMacbeeNews) {
        $(event.target).prop('checked', false);
      } else {
        $(event.target).prop('checked', true);
      }
      alert('更新に失敗しました');
    });
  }
}
